module.exports = __webpack_public_path__ + "static/media/edit_green.45464a70.svg";